import { type SnakeCase, toSnakeCase } from "@/shared/utils/toSnakeCase/toSnakeCase"

type DeepSnakeCasedKeys<T> = T extends (infer U)[]
  ? DeepSnakeCasedKeys<U>[]
  : T extends object
    ? {
        [K in keyof T as SnakeCase<string & K>]: DeepSnakeCasedKeys<T[K]>
      }
    : T

const isPlainObject = (obj: unknown): obj is Record<string, unknown> => {
  return typeof obj === "object" && obj !== null && Object.getPrototypeOf(obj) === Object.prototype
}

export const toSnakeCasePropertiesDeep = <T>(obj: unknown): DeepSnakeCasedKeys<T> => {
  if (Array.isArray(obj)) {
    return obj.map((item) => toSnakeCasePropertiesDeep<unknown>(item)) as DeepSnakeCasedKeys<T>
  }

  if (!isPlainObject(obj)) {
    return obj as DeepSnakeCasedKeys<T>
  }

  return Object.entries(obj).reduce<Record<string, unknown>>((acc, [key, value]) => {
    const snakeKey = toSnakeCase(key)
    acc[snakeKey] = toSnakeCasePropertiesDeep<unknown>(value)
    return acc
  }, {}) as DeepSnakeCasedKeys<T>
}
